import {
	type RetainerPeriod,
	type Project,
	type TabKey,
} from '@/generated/graphql';
import { Constants } from '@/constants';
import { useMainStore } from '@/stores/main';

export const getTabRouteUrl = (
	projectId: Project['id'],
	link: string,
	retainerPeriodId?: RetainerPeriod['id']
) => {
	return (
		`/${Constants.Module.PROJECTS.name}/${Constants.Action.VIEW}/${projectId}${link}` +
		(retainerPeriodId ? `?retainerPeriodId=${retainerPeriodId}` : '')
	);
};

export const getTabRouteName = (key: TabKey) => {
	return `project-tab-${key.toLowerCase()}`;
};

export const removeLastWordFromPath = (path: string) => {
	const regex = /\/([^\/]+)$/;

	return path.replace(regex, '');
};

export const reloadPageWithoutLastSegment = () => {
	const currentUrl = window.location.href;
	const lastSlashIndex = currentUrl.lastIndexOf('/');
	const newUrl = currentUrl.substring(0, lastSlashIndex + 1);

	window.location.href = newUrl;
};

export const getProjectTabLabelByKey = (key: TabKey) => {
	const { t } = useMainStore().translation;
	return t(`project.tab.${key.toLocaleLowerCase()}`);
};
